<template>
  <div>
    <learning-item-details
      v-if="showStats"
      :item="item"
    ></learning-item-details>
    <v-row>
      <v-btn class="default-action-btn spaced-btn" @click="$router.go(-1)">
        Course Overview
      </v-btn>
      <v-btn
        class="default-action-btn spaced-btn"
        @click="showStats = !showStats"
      >
        {{ showStats ? "Hide Stats" : "Show Stats" }}
      </v-btn>
      <v-spacer />
      <v-switch class="mr-2" v-model="hidden" label="Hidden"></v-switch>
      <v-btn
        id="js-item-edit-button"
        class="d-flex justify-end default-action-btn"
        @click="
          $router.replace({
            name: 'learningItemManager',
            query: { edit: true }
          })
        "
        v-if="!edit"
      >
        Edit
      </v-btn>
      <v-btn
        id="js-item-view-button"
        class="d-flex justify-end default-action-btn"
        @click="
          $router.replace({
            name: 'learningItemManager'
          })
        "
        v-if="edit"
      >
        Preview
      </v-btn>
    </v-row>
    <learning-item-edit :item="item" v-if="edit" />
    <learning-item-view :item="item" v-else />
  </div>
</template>
<script>
import eventMixin from "@/mixins/eventMixin"
import LearningItemEdit from "@/containers/learnings/LearningItemEdit"
import LearningItemView from "@/containers/learnings/LearningItemView"
import LearningItemDetails from "@/containers/learnings/LearningItemDetails"

export default {
  mixins: [eventMixin],
  components: {
    LearningItemEdit,
    LearningItemView,
    LearningItemDetails
  },
  props: {
    edit: { type: Boolean, default: true },
    responsesComplete: { type: Boolean, default: false }
  },
  computed: {
    hidden: {
      get() {
        return this.item.hidden
      },
      set(value) {
        this.$store.dispatch("learningItems/updateLearningItem", {
          id: this.item.id,
          hidden: value
        })
      }
    },
    item() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.learningItemId
      )
      return item ? item : {}
    },
    responses() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.learningItemId
      )
      return item && item.responses ? item.responses : []
    },
    badgeUrl() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.learningItemId
      )
      return item ? item.badge_url : ""
    }
  },
  data() {
    return {
      learningItemId: this.$route.params.id,
      showAssignBadge: false,
      showStats: false
    }
  },
  created() {
    this.$store.dispatch("learningItems/loadLearningItems")

    this.addListener("learning:save", ({ id, body, description, name }) => {
      this.$store.dispatch("learningItems/updateLearningItem", {
        id,
        body,
        description,
        name
      })
    })
    this.addListener("learningResponse:add", ({ itemId, key }) => {
      this.$store.dispatch("learningItems/addLearningItemResponse", {
        itemId,
        key
      })
    })
    this.addListener("learningResponse:save", model => {
      this.$store.dispatch("learningItems/updateLearningItemResponse", {
        id: model.id,
        key: model.key,
        type: model.type,
        options: model.options
      })
    })
    this.addListener("learningResponse:remove", model => {
      this.$store.dispatch("learningItems/deleteLearningItemResponse", model.id)
    })
  },
  methods: {
    selectBadge(badge) {
      this.$store.dispatch("learningItems/updateLearningItem", {
        id: this.learningItemId,
        badgeId: badge.id
      })
      this.showAssignBadge = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.spaced-btn {
  margin: 0px 5px;
}
.center-align {
  display: flex;
  justify-content: center;
}
</style>
